<template>
    <div>
        <div class="rtitle flex justify-between align-center bg-white rone">
            <div class="colorleft">企业简介</div>
            <div class="editbtn pointer" @click="edit = 1" v-if="edit == 0">编辑</div>
            <div class="editbtn pointer" @click="tosubedit" v-if="edit == 1">确定</div>
        </div>
        <div class="cball">
            <div class="bg-white" style="padding: 40px;min-height: 480px;">
                <div class="" v-if="userinfo">
                    <tinymce v-if="edit == 1" v-model="userinfo.shop.content" :height="300" />
                    <div class="" style="min-height: 340px;" v-else>
                        <div style="width: 100%;word-break: break-all;overflow: hidden;" v-if="userinfo.shop.content" v-html="userinfo.shop.content" ></div>
                        <div style="width: 100%;word-break: break-all;overflow: hidden;" v-else>
                            <el-empty description="暂无数据"></el-empty>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { mapGetters } from "vuex";
  import Tinymce from '@/components/Tinymce'
export default ({
    components: { Tinymce },
    computed:{
        ...mapGetters(["token"])
    },
    data() {
        return{
            config: '',
            userinfo: '',
            edit: 0
        }
    },
    methods:{
        getconfig(){
            this.$api.index.config().then(res=>{
                this.config = res.data;
            })
        },
        tosubedit(){
            console.log(this.userinfo.shop)
            if(!this.userinfo.shop.content){
                this.$message.error('请输入内容')
                return false;
            }
            var data = {
                content: this.userinfo.shop.content,
                id: this.userinfo.shop.id
            }
            this.$api.index.intro_edit(data).then(res=>{
                console.log(res)
                this.$message.success(res.msg)
                this.edit = 0;
                this.getuserinfo();
            })
        },
        getuserinfo(){
            var type = localStorage.getItem('type');
            if(type == 2){
                var types = 1;
            }else if(type == 1){
                var types = 2;
            }
            var data = {
                user_id: this.token,
                type: types
            }
            this.$api.user.userinfo(data).then(res=>{
                var data = res.data;
                var regex = new RegExp('<img','gi');
                var content = res.data.shop.content;
                if(content){
                    res.data.shop.content = content.replace(regex,`<img style="max-width: 100%;height: auto"`)
                }
                this.userinfo = data;
                var sdata = JSON.stringify(data)
                // this.$store.commit('SET_USERINFO',sdata)
                localStorage.setItem('userinfo', sdata)
            })
        }
    },
    created(){
        this.getuserinfo();
        this.getconfig();
    }
})
</script>

<style scoped>
    .rtitle{
        padding: 16px 20px;
        font-size: 16px;
        color: #7d7d7d;
        border-bottom: 8px solid #f4f4f4;
    }
    .rone{
        border-radius: 12px 12px 0 0;
    }
    .colorleft{
        color: #191919;font-size: 20px;
    }
    .colorright{
        color: #7e7e7e;font-size: 18px;
    }


    .editbtn{
        width: 92px;
        height: 34px;
        line-height: 34px;
        text-align: center;color: #fff;font-size: 16px;
        background-color: #1759d8;
        border-radius: 4px;
    }


    .cball{
        border-radius: 0 0 12px 12px;overflow:hidden;
    }
    .c_img{
        width: 33px;height: 33px;margin-right: 15px;
    }
    .contact{
        height: 105px;
        line-height: 105px;
        border-bottom: 1px solid #eee;
        padding: 0 60px;
    }
</style>


// WEBPACK FOOTER //
// company_brief.vue?832ca00c